

import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,

      f_c: {
        desde: this.date_rest(this.currentdate(), -6),
        hasta: this.currentdate(),
        estado: false
      },
      tabla: {
        meses: [],
        data: []
      }


    };
  },

  computed: {
    reporte: function () {
      return '/SERVER/scd/excel/?dsis=' + window.sssdi + '&a=cuponesLi' + '&desde=' + this.f_c.desde + '&hasta=' + this.f_c.hasta + '&filt=' + this.f_c.estado

    }
  },

  mounted: function () {
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,

      'rowCallback': function (row, data, index) { },



    });
    $('.box').boxWidget();

  },

  methods: {

    descargar() {

      this.to_excel_name2($("#dett").html(), 'dett', 'Venta por Terminal');

    },
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/SERVER/scd/estadisticas/', {
          'a': 'ventaDi',
          'f': this.f_c
        }, {
          withCredentials: true
        })
        .then(response => {

          this.ventast_tabla = 0;
          if (response.data.status == 1) {

            this.tabla.meses = response.data.meses;

            let totales = ["Totales", 0.0];
            for (let i = 0; i < response.data.meses.length; i++) {
              totales.push(0.0);

            }

            for (let i = 0; i < response.data.data.length; i++) {
              for (let h = 1; h < response.data.data[i].length; h++) {


                if (response.data.data[i][h] != null) {
                  totales[h] += parseFloat(response.data.data[i][h].replace(',', '.'));
                }


              }


            }

            for (let i = 1; i < totales.length; i++) {
              totales[i] = totales[i].toFixed(2).toString().replace('.', ',');

            }


            response.data.data.push(totales);


            this.tabla.data = response.data.data;

          }


          this.loading = false;
        });


    },

  }


};



// WEBPACK FOOTER //
// ./src/components/estadisticas/ventaDia/tventas/tventas.js